// RecordLayout (was JobLayout, HIERARCHY.md follow-up 3): a record page's body: the work on the left (its Areas), the people and the
// place on the right in a narrower column, divided by a hairline. 320 wide, 296 under 1360, and one
// column under 1100, the side after the work over a rule. Right under a record's figures (underFigures, the
// invoice sheet's), their rule is the divider: the first Section in each column draws none of its own, as
// ListPage's and DashboardPage's regions do. Reads only --recordlayout-*.
import type { ReactNode } from 'react';
import './RecordLayout.css';

export interface RecordLayoutProps {
  main: ReactNode;
  side: ReactNode;
  /** The side column's name, for screen readers ("Customer, site and details"). */
  sideLabel: string;
  /** It sits right under the record's figures, whose rule divides them: no second line. */
  underFigures?: boolean;
}

export function RecordLayout({ main, side, sideLabel, underFigures = false }: RecordLayoutProps) {
  return (
    <div className="fl-recordlayout" data-figures={underFigures ? '' : undefined}>
      <div className="fl-recordlayout__main">{main}</div>
      <aside className="fl-recordlayout__side" aria-label={sideLabel}>
        {side}
      </aside>
    </div>
  );
}
